import { http_client } from "../plugins/http_client";

const getEvaluaciones = async (params={}) => await http_client("/api/v1/mantenimiento-evaluaciones", params, 'get');
const agregarEvaluacion = async (params) => await http_client("/api/v1/mantenimiento-evaluaciones", params, 'post');
const editarEvaluacion = async (id, params) => await http_client(`/api/v1/mantenimiento-evaluaciones/${id}`, params, 'put');
const cambiarEstadoEvaluacion = async (id) => await http_client(`/api/v1/mantenimiento-evaluaciones/${id}/cambiar-estado`, {}, 'patch');

export default {
  getEvaluaciones,
  agregarEvaluacion,
  editarEvaluacion,
  cambiarEstadoEvaluacion
};